import { Button } from '@techem/ui-components';
import { KIND } from 'baseui/button';
import { SIZE } from 'baseui/input';
import React, { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { setBillingPeriod } from 'frameworks_drivers/redux/reducers/onboardingInformation/onboardingInformationSlice';
import store from 'store';
import BillingPeriodStartFormControl from '../BillingPeriod/components/BillingPeriodStartFormControl';
import useBillingPeriod from '../../../../tools/hooks/useBillingPeriod';

interface EditBillingPeriodViewProperties {
  callbackOnSuccess: () => void;
  callbackOnAbort: () => void;
}

const EditBillingPeriodView: FC<EditBillingPeriodViewProperties> = (props) => {
  const { t } = useTranslation();
  const { billingPeriodSet, selectedIndex, setSelectedIndex } = useBillingPeriod();

  const handleAbort = () => {
    props.callbackOnAbort();
  };

  const handleSubmit = () => {
    const billingDateStart = billingPeriodSet.getBillingPeriodByIndex(selectedIndex).getStart();
    const billingDateEnd = billingPeriodSet.getBillingPeriodByIndex(selectedIndex).getEnd();

    const billingDateStartUTC = new Date(
      Date.UTC(
        billingDateStart.getFullYear(),
        billingDateStart.getMonth(),
        billingDateStart.getDate()
      )
    );
    const billingDateEndUTC = new Date(
      Date.UTC(billingDateEnd.getFullYear(), billingDateEnd.getMonth(), billingDateEnd.getDate())
    );

    store.dispatch(
      setBillingPeriod({
        startDate: billingDateStartUTC.toISOString(),
        endDate: billingDateEndUTC.toISOString()
      })
    );

    props.callbackOnSuccess();
  };

  return (
    <Col xs={12} className="my-4">
      <Row>
        <span className={'fw-bold fs-6 lh-base my-2'} style={{ color: 'rgb(33, 37, 41)' }}>
          {t('pageBillingPeriodLabelStartDate')}
        </span>
        <Col xs={12}>
          <BillingPeriodStartFormControl
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            billingPeriodSet={billingPeriodSet}
          />
        </Col>
        <Col xs={12}>
          <div className="d-flex h-100">
            <span className="m-auto" style={{ lineHeight: '20px' }}>
              {t('pageBillingPeriodLabelBetweenDates')}
            </span>
          </div>
        </Col>
        <Col xs={12} className="text-center">
          <span className="m-auto" style={{ lineHeight: '20px' }}>
            {billingPeriodSet
              .getBillingPeriodByIndex(selectedIndex)
              .getEnd()
              .toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              })}
          </span>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md="auto">
          <Row className="justify-content-center">
            <Col
              xs={12}
              sm="auto"
              className="my-1 order-last order-sm-first order-md-last text-center"
            >
              <Button
                kind={KIND.secondary}
                size={SIZE.large}
                onClick={() => {
                  handleAbort();
                }}
              >
                {t('summaryEditAbortButtonText')}
              </Button>
            </Col>
            <Col xs="auto" className="my-1 text-center">
              <Button
                size={SIZE.large}
                onClick={() => {
                  handleSubmit();
                }}
              >
                {t('summaryEditSaveButtonText')}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default EditBillingPeriodView;
